export default "__VITE_ASSET__fYXQsLnI__"